import { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';
import { ContextualGate, type GateSurface } from '@/components/gates/ContextualGate';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Superfície do gate — muda copy e ghost preview quando o usuário não está logado. */
  gate?: GateSurface;
}

export const ProtectedRoute = ({ children, gate }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <ContextualGate surface={gate ?? 'default'} />;
  }

  return <>{children}</>;
};
